module.exports = __webpack_public_path__ + "img/The_Beatles_Hey_Jude_Trident_Studios_Small_Imag.original.4cd16eb9.jpg";